import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SplitText from "@/components/ui/SplitText";
import parceiroIgrejaVozSalvacao from "@/assets/parceiro-igreja-voz-salvacao.png";
import parceiroOsmar from "@/assets/parceiro-osmar.png";
import parceiroIgrejaMissionariaBetesda from "@/assets/parceiro-igreja-missionaria-betesda.png";
const HeroSection = () => {
  const [isCursorClicked, setIsCursorClicked] = useState(false);

  useEffect(() => {
    const animationLoop = () => {
      setTimeout(() => setIsCursorClicked(true), 2250);
      setTimeout(() => setIsCursorClicked(false), 2600);
    };
    const initialDelay = setTimeout(animationLoop, 100);
    const interval = setInterval(animationLoop, 6000);
    return () => { clearTimeout(initialDelay); clearInterval(interval); };
  }, []);

  return <section className="hero-sky border-b border-border/60">
      <div className="section-shell grid gap-12 lg:grid-cols-2 lg:items-start">
        {/* Texto principal */}
        <div className="space-y-6 fade-in-up max-w-xl lg:pt-4">
          <div className="badge-soft">Plantando evangelho • Regando esperança</div>

          <SplitText tag="h1" text="Voz para anunciar salvação e mãos para suprir o necessitado" className="text-4xl md:text-5xl lg:text-6xl font-semibold text-neutral-black" splitType="chars,words" delay={80} duration={0.6} ease="power3.out" from={{
          opacity: 0,
          y: 40
        }} to={{
          opacity: 1,
          y: 0
        }} textAlign="left" />

          <h2 className="text-base md:text-lg font-semibold tracking-[0.18em] uppercase text-primary/90">UNIMOS EVANGELISMO, DISCIPULADO E AÇÃO SOCIAL PARA SOCORRER A CRIAÇÃO DE DEUS E EDIFICAR A IGREJA DO SENHOR.</h2>

          <div className="flex flex-wrap items-center gap-4">
            <Button
              asChild
              size="lg"
              className="btn-pill-lg hero-orbit hover-lift text-primary-foreground shadow-lg hover:brightness-110"
            >
              <a href="https://www.instagram.com/iessa.instituto/" target="_blank" rel="noreferrer">
                Conheça nossa missão
              </a>
            </Button>
          </div>

          <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground/90">
            PLANTANDO EVANGELHO E REGANDO ESPERANÇA!
          </p>

          {/* Blog Card com cursor animado */}
          <div className="pt-4">
            <div className="relative group max-w-xs">
              {/* Borda offset decorativa */}
              <div className="absolute top-2.5 left-2.5 w-full h-full border-2 border-foreground rounded-2xl bg-transparent transition-transform duration-300 group-hover:translate-x-1 group-hover:translate-y-1" />

              {/* Conteúdo do card */}
              <div className="relative bg-card border-2 border-foreground rounded-2xl p-5 shadow-xl transition-transform duration-200">
                <div className="inline-block px-2.5 py-0.5 mb-3 border border-foreground/30 rounded-full bg-primary/10">
                  <span className="text-[10px] font-bold tracking-[0.2em] text-foreground uppercase">
                    Edificação • Leitura
                  </span>
                </div>

                <h3 className="text-xl font-bold text-foreground mb-2 leading-tight">
                  Explore nosso<br />Blog Cristão
                </h3>

                <p className="text-foreground/80 text-xs font-medium tracking-wide leading-relaxed mb-5 uppercase">
                  Artigos sobre evangelismo, discipulado e histórias que edificam a fé.
                </p>

                <Link
                  to="/blog"
                  className={`
                    w-full relative overflow-hidden group/btn
                    flex items-center justify-center gap-3
                    bg-foreground text-background
                    py-3.5 px-5 rounded-xl
                    font-bold text-base tracking-wide
                    transition-all duration-200
                    shadow-[0_4px_14px_0_hsl(var(--foreground)/0.39)]
                    hover:shadow-[0_6px_20px_hsl(var(--foreground)/0.23)]
                    hover:-translate-y-1
                    active:translate-y-0 active:scale-95
                    ${isCursorClicked ? 'scale-95 ring-4 ring-primary/50' : ''}
                  `}
                >
                  <span className="relative z-10">LER ARTIGOS</span>
                  <ArrowRight className="w-5 h-5 relative z-10 transition-transform duration-300 group-hover/btn:translate-x-1" />
                  <div className="absolute inset-0 bg-primary/10 translate-y-full group-hover/btn:translate-y-0 transition-transform duration-300" />
                </Link>
              </div>

              {/* Cursor animado */}
              <div className="pointer-events-none absolute z-50 animate-[cursor-card-move_6s_infinite_ease-in-out]">
                <svg
                  width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                  className={`drop-shadow-xl transition-transform duration-100 ${isCursorClicked ? 'scale-75' : 'scale-100'}`}
                >
                  <path d="M3 3L10.07 19.97L12.58 12.58L19.97 10.07L3 3Z" fill="hsl(var(--foreground))" stroke="hsl(var(--background))" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                {isCursorClicked && (
                  <div className="absolute top-0 left-0 -ml-2 -mt-2 w-10 h-10 rounded-full border-2 border-foreground animate-ping opacity-75" />
                )}
              </div>

              {/* Badge NOVO */}
              <div className="absolute -top-3 -right-3 bg-[#FDE68A] text-foreground text-[10px] font-bold px-2.5 py-0.5 rounded-lg border-2 border-foreground shadow-[3px_3px_0px_0px_hsl(var(--foreground))] transform rotate-12">
                NOVO
              </div>
            </div>
          </div>
        </div>

        {/* Cartões ilustrativos */}
        <div className="relative flex max-w-md flex-col gap-5 mx-auto lg:max-w-lg lg:pt-4 lg:pl-4">
          {/* Cartão principal com logo */}
          <div className="card-ambient hover-lift parallax-card animate-fade-in anim-delay-1 p-6 md:p-8 flex flex-col items-center text-center gap-4">
            <div className="inline-flex items-center justify-center rounded-2xl bg-primary/10 p-3 md:p-4">
              <img alt="Logotipo do Instituto Evangelístico e Social Sabedoria do Alto" className="h-16 w-16 sm:h-20 sm:w-20 md:h-24 md:w-24 lg:h-28 lg:w-28 object-contain drop-shadow-[0_0_36px_hsl(var(--primary)/0.6)]" fetchPriority="high" width={112} height={112} src="/lovable-uploads/1154ac9b-2b1e-4222-8cea-22881e742e62.png" />
            </div>
            <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-primary">
              Instituto Evangelístico e Social
            </p>
            <p className="text-sm md:text-base font-medium text-neutral-black">
              Uma casa de ensino, cuidado e envio para quem deseja servir com profundidade bíblica e sensibilidade
              social.
            </p>
          </div>

          {/* Linha de cards de destaque */}
          <div className="grid gap-4 md:grid-cols-2">
            <div className="card-ambient hover-lift parallax-card animate-fade-in anim-delay-2 p-4 flex flex-col gap-2">
              <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-secondary">
                Missões Caatinga
              </span>
              <p className="text-sm font-semibold text-neutral-black">Impacto social e espiritual no sertão.</p>
              <p className="text-xs text-muted-foreground">
                Visitas regulares, assistência básica e proclamação do evangelho em comunidades vulneráveis.
              </p>
            </div>

            <div className="card-ambient hover-lift parallax-card animate-fade-in anim-delay-3 p-4 flex flex-col gap-2">
              <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-primary">
                Curso de Teologia
              </span>
              <p className="text-sm font-semibold text-neutral-black">Formação bíblica para a igreja local.</p>
              <p className="text-xs text-muted-foreground">
                Aulas presenciais e online para capacitar obreiros e líderes comprometidos com a Palavra.
              </p>
            </div>
          </div>

          {/* Card opcional de comunidade/igreja */}
          <div className="card-ambient hover-lift parallax-card animate-fade-in anim-delay-3 p-4 flex items-start gap-3">
            <div className="h-8 w-8 rounded-full bg-secondary/20 flex items-center justify-center">
              <span className="text-xs font-semibold text-secondary">⛪</span>
            </div>
            <div className="space-y-1">
              <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-muted-foreground">
                Igreja & Comunidade
              </span>
              <p className="text-sm font-semibold text-neutral-black">Caminhando junto com a igreja local.</p>
              <p className="text-xs text-muted-foreground">
                Servimos em parceria com igrejas, fortalecendo comunidades e integrando fé, serviço e esperança.
              </p>
            </div>
          </div>

          {/* Card de parceiros de missão com seta indicativa */}
          <div className="flex flex-col items-stretch gap-2 animate-fade-in anim-delay-4">
            <div className="flex items-center gap-2 text-xs font-medium text-muted-foreground">
              <span className="h-px flex-1 bg-border" aria-hidden="true" />
              <span className="inline-flex items-center gap-1">
                <span>parceiros de missão</span>
                <span className="text-secondary">⬇</span>
              </span>
              <span className="h-px flex-1 bg-border" aria-hidden="true" />
            </div>

            <div className="card-ambient hover-lift parallax-card p-4 flex flex-col gap-3">
              <div className="flex items-center justify-between gap-3">
                <div className="space-y-1">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-secondary">
                    Parceiros em campo
                  </p>
                  <p className="text-sm font-semibold text-neutral-black">
                    Quem caminha conosco levando esperança.
                  </p>
                </div>
              </div>

              <div className="space-y-3">
                {/* Parceiro 1 */}
                <div className="flex items-center gap-3">
                  <div className="h-9 w-9 rounded-full overflow-hidden border border-secondary/40 flex items-center justify-center bg-secondary/15">
                    <img src={parceiroIgrejaVozSalvacao} alt="Logo da Igreja Voz da Salvação, parceira de missão" className="h-full w-full object-cover" loading="lazy" width={36} height={36} />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs font-medium text-neutral-black">Igreja Voz da Salvação</span>
                    <a href="https://www.instagram.com/igreja.voz.da.salvacao" target="_blank" rel="noreferrer" className="text-xs font-semibold text-secondary hover:underline">
                      @igreja.voz.da.salvacao
                    </a>
                  </div>
                </div>

                {/* Parceiro 2 */}
                <div className="flex items-center gap-3">
                  <div className="h-9 w-9 rounded-full overflow-hidden border border-primary/40 flex items-center justify-center bg-primary/10">
                    <img src={parceiroOsmar} alt="Foto do parceiro de missão Pr. Osmar Oliveira" className="h-full w-full object-cover" loading="lazy" width={36} height={36} />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs font-medium text-neutral-black">Pr. Osmar Oliveira</span>
                    <a href="https://www.instagram.com/pr_osmar_oliveira" target="_blank" rel="noreferrer" className="text-xs font-semibold text-primary hover:underline">
                      @pr_osmar_oliveira
                    </a>
                  </div>
                </div>

                {/* Parceiro 3 */}
                <div className="flex items-center gap-3">
                  <div className="h-9 w-9 rounded-full overflow-hidden border border-secondary/40 flex items-center justify-center bg-secondary/15">
                    <img src={parceiroIgrejaMissionariaBetesda} alt="Logo da Igreja Missionária Betesda, parceira de missão" className="h-full w-full object-cover" loading="lazy" width={36} height={36} />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs font-medium text-neutral-black">Igreja Missionária Betesda</span>
                    <a href="https://www.instagram.com/igreja_missionaria_betesda05" target="_blank" rel="noreferrer" className="text-xs font-semibold text-secondary hover:underline">
                      @igreja_missionaria_betesda05
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default HeroSection;